/**
 * URL validation utilities to prevent open redirect and javascript: URI attacks.
 * All window.open() calls should use safeWindowOpen() instead.
 */

/**
 * Validates a URL and returns the safe href, or null if unsafe.
 * Allows http: and https: protocols only. Relative URLs are resolved against origin.
 */
export const getSafeUrl = (url) => {
  if (!url || typeof url !== "string") return null;
  try {
    const parsed = new URL(url, window.location.origin);
    if (parsed.protocol === "http:" || parsed.protocol === "https:") {
      return parsed.href;
    }
    return null;
  } catch {
    return null;
  }
};

/**
 * Safe replacement for window.open(). Validates URL before opening.
 * Returns the Window reference if opened, or null if blocked.
 */
export const safeWindowOpen = (url, target = "_blank") => {
  const safe = getSafeUrl(url);
  if (!safe) {
    console.warn("[urlValidator] Blocked unsafe URL:", url);
    return null;
  }
  return window.open(safe, target, "noopener,noreferrer");
};

/**
 * Safe download via anchor element. Validates URL before creating download link.
 */
export const safeDownload = (url) => {
  const safe = getSafeUrl(url);
  if (!safe) {
    console.warn("[urlValidator] Blocked unsafe download URL:", url);
    return;
  }
  const link = document.createElement("a");
  link.href = safe;
  link.setAttribute("download", "");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
